import CityPageTemplate from "../city-template/CityPageTemplate";
import { brightonConfig } from "./data";

export default function BrightonPage() {
  return <CityPageTemplate config={brightonConfig} />;
}